const notificationtemplates = {
	title: "Varslingsmaler",
	new_notificationtemplate: "Ny mal",
	edit_notificationtemplate: "Rediger mal: {name}",
	view_notificationtemplate: "Vis mal: {name}",
	list_title: "Epostmaler",
	create_title: "Opprett epostmal",
	update_title: "Oppdater epostmal",
	id: "ID",
	coursetemplate_id: "Kursmal",
	slug: "Slug",
	subject: "Emne",
	template: "Mal",
	description: "Kort beskrivelse",
	trigger: "Trigger",
	type: "Type",
	update_existing: "Oppdater kursmaler",
	update_existing_confirm: "Vil du oppdatere alle eksisterende kursmaler med denne epostmalen?",
	available_tags: "Plassholdere",
	status: "Status",
	select_template: "Velg mal",
	message: "Melding",
	email_notification: "Epost varsling",
	sms_notification: "SMS varsling",
	notification_sent_successfully: "Varslingene er sendt",
	notification_sent_failed: "Varslingene er ikke sendt",
	cc_me: "Kopi til meg",
	bcc_me: "BCC til meg",
};
export default notificationtemplates;